module.exports = __webpack_public_path__ + "static/media/reload-orange.99c0413d.png";